import Loadable from "../Pages/Layout/loadable/Loadable";
import { lazy } from "react";

export const FULLLAYOUT = Loadable(
  lazy(() => import("../Pages/Layout/FullLayout"))
);

export const DASHBOARD = Loadable(
  lazy(() => import("../Pages/Dashboard/Dashboard"))
);
export const BLAKEOUT = Loadable(
  lazy(() => import("../Pages/Layout/blank-layout/BlankLayout"))
);
export const USER_MANAGEMENT = Loadable(
  lazy(() => import("../Pages/User_Managment/User_Management"))
);
export const CLEANER_MANAGEMENT = Loadable(
  lazy(() => import("../Pages/Cleaner_Management/Cleaner_Management"))
);
export const PROPERTY_MANAGEMENT = Loadable(
  lazy(() => import("../Pages/Property_Management/Property_Management"))
);
export const SUBSCRIPTION_MANAGEMENT = Loadable(
  lazy(() => import("../Pages/Subscription_Management/Subscription_Management"))
);
export const SETTING_MANAGEMENT = Loadable(
  lazy(() => import("../Pages/Setting/Setting"))
);
export const  PROFILE = Loadable(
  lazy(() => import("../Pages/Profile"))
);
export const NOTIFICATION=Loadable(
  lazy(()=>import("../Pages/Notification"))
);
export const  HOSTHELPERHELPER=Loadable(
  lazy(()=> import ("../Pages/Webviewhosthelper/Web_View_Host_Helper"))
);

export const LOGIN = Loadable(lazy(() => import("../Pages/AUTH/Login/Login")));
